/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import CardInfo from '../CardInfo';

const Infos = ({ ENABLE_MMO }) => {

    const instructionClassName = !ENABLE_MMO ? 'display-none' : '';

    const canModifyOrderInfoCard = (className = '') => {
        const title = (
            <>
                Orders That <span className="bold">Can</span> Be Modified
            </>
        );
        const body = (
            <>
                <ul className="no-margin-top">
                    <li>
                        To edit a section, click the <b>MODIFY</b> button.
                    </li>
                    <li>
                        Each order can be modified once. Edit all sections
                        before clicking <b>SUBMIT</b>.
                    </li>
                    <li>You’ll receive an email confirming your changes.</li>
                </ul>
                <div>Payment details cannot be edited online.</div>
            </>
        );
        return <CardInfo className={className} title={title} body={body} />;
    };

    const cannotModifyOrderInfoCard = (className = '') => {
        const title = (
            <>
                Orders That <span className="bold">Cannot</span> Be Modified
            </>
        );
        const body = (
            <div className="no-margin-top">
                <div>
                    <span className="error-color bold">
                        “This Order May No Longer Be Modified”
                    </span>{' '}
                    means that your order has been processed and is ready to be
                    shipped, in-transit, or out for delivery.
                </div>
            </div>
        );
        return <CardInfo className={className} title={title} body={body} />;
    };

    return (
        <>
            {canModifyOrderInfoCard(instructionClassName)}
            {cannotModifyOrderInfoCard(instructionClassName)}
        </>
    );
}

Infos.defaultProps = {
    ENABLE_MMO: false,
};

Infos.propTypes = {
    ENABLE_MMO: PropTypes.bool,
};

export default Infos;
